import type { RefObject } from 'react'

import { useEffect, useState } from 'react'

interface InViewOptions {
    once?: boolean
    rootMargin?: string
    threshold?: number
}

export const useInView = <T extends Element>(
    ref: RefObject<T | null>,
    { once = true, rootMargin = '0px 0px -10% 0px', threshold = 0.12 }: InViewOptions = {}
): boolean => {
    const [inView, setInView] = useState(false)

    useEffect(() => {
        const node = ref.current

        if (!node) return

        if (typeof IntersectionObserver === 'undefined') {
            setInView(true)
            return
        }

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setInView(true)
                if (once) observer.disconnect()
            }
            else if (!once) {
                setInView(false)
            }
        }, { rootMargin, threshold })

        observer.observe(node)

        return () => observer.disconnect()
    }, [ref, once, rootMargin, threshold])

    return inView
}
